import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "./store";
import { AssetsService } from "../services/Assets.Service";
import { Asset } from "../models/Assets";
import { getOrgId, tryGetOrgId } from "./orgHelpers";

interface AssetsSlice {
    assets: Asset[],
    banks: Array<any> | null,
    modalAssetsStatus:boolean,
    investing: any,
    networks: Array<any> | null
}

const initialState: AssetsSlice = {
    assets: [],
    banks: null,
    modalAssetsStatus: false,
    investing: null,
    networks: null
};

const assetsSlice = createSlice({
    name: 'assets',
    initialState,
    reducers: {
        setAssets: (state, action: PayloadAction<Asset[]>) => {
            state.assets = action.payload;
        },
        setModalAssetStatus: (state, action: PayloadAction<boolean>) => {
            state.modalAssetsStatus = action.payload;
        },
        setBanks: (state, action: PayloadAction<Asset[]>) => {
            state.banks = action.payload;
        },
        setInvesting: (state, action: PayloadAction<any>) => {
            state.investing = action.payload;
        },
        setNetworks: (state, action: PayloadAction<any>) => {
            state.networks = action.payload;
        }
    }
  });
  
export const {
    setAssets,
    setModalAssetStatus,
    setBanks,
    setInvesting,
    setNetworks
} = assetsSlice.actions;

// customs func
// Assets
export const getAssetsList          = (state: RootState): Asset[] => state.assets.assets;
export const getModalAssetsStatus   = (state: RootState): boolean => state.assets.modalAssetsStatus;
export const getInvesting           = (state: RootState): any => state.assets.investing;
export const getNetworks            = (state: RootState): any => state.assets.networks;

export const fetchAssets = () : AppThunk<Promise<void>> => async (dispatch, getState) => {
    const state = getState();
    // Assets sao escopados por organizacao. Usuarios sem org (ex.: cliente
    // recem-registrado, depositor) nao tem assets de org — pula sem quebrar.
    const orgId = tryGetOrgId(state);
    if (!orgId) return;
    const assetsResponse : any = await AssetsService.getAllAssets(orgId);
    dispatch(setModalAssetStatus(false));
    dispatch(setAssets(assetsResponse));
}

export const addAssets = (payload:Asset) : AppThunk<Promise<void>> => async (dispatch, getState) => {
    const state = getState();
    const id = getOrgId(state);
    const assetsResponse : any = await AssetsService.createAsset(payload, id);
    dispatch(fetchAssets());
}

// Banks
export const getBanksList = (state: RootState): any[] | null => state.assets.banks;

export const fetchBanks = () : AppThunk<Promise<void>> => async (dispatch, getState) => {
    const bankResponse : any = await AssetsService.getAllBanks();
    dispatch(setBanks(bankResponse));
}

export const fetchNetowrks = () : AppThunk<Promise<void>> => async (dispatch, getState) => {
    const networksResponse : any = await AssetsService.getAllNetworks();
    dispatch(setNetworks(networksResponse));
}
// investing teste
export const fetchInvesting = () : AppThunk<Promise<void>> => async (dispatch, getState) => {
    const investingResponse : any = await AssetsService.getInvesting();
}


export default assetsSlice.reducer;
